module.exports = __webpack_public_path__ + "img/Group 916.712c67ff.png";